import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../models/base/base.component';
import { InvoiceService } from '../../services/invoice.service';
import { LookupService } from '../../services/lookup.service';
import { NavigationService } from '../../services/navigation.service';
import { FileService } from '../../services/file.service';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { carrierPaymentType } from '../orders/order-form.component';
import { environment } from '../../environments/environment';
import { SharedService } from '../../services/shared.service';
import { AccountService } from '../../services/account.service';
import { ApplicationInsightsService } from '../../services/application-insights.service';
import * as Sentry from '@sentry/angular';
import { formatCurrency } from '../helper/currency.utils';

@Component({
  selector: 'invoice-detail',
  templateUrl: './invoice-detail.component.html',
  providers: [InvoiceService, LookupService, FileService]
})
export class InvoiceDetailComponent extends BaseComponent implements OnInit {
  @Input() model: any = null;
  @Input() showHeader: boolean = true;
  @Input() showVehicles: boolean = true;
  @Input() showModal: boolean = true;
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  invoiceComplete: boolean = false;
  invoicePaid: boolean = false;
  loaded = false;
  carrierPaymentStatus:any
  isAdmin: boolean = false;
  lookups = {};
  metadata = {};
  detailMetadata = {};
  dirty = false;
  showCancelWarning = false;
  carrierPhones = [];
  pickupPhones = [];
  deliveryPhones = [];
  driverPhones = [];
  driverNames = [];
  cargoLimit = [];
  cargoInsuranceDeductible = [];
  customerExpectedDeliveryDates = [];
  customerExpectedPickupDates = [];
  pickupNewETADates = [];
  deliveryNewETADates = [];
  carrierScheduledPickupDates = [];
  carrierScheduledDeliveryDates = [];
  dateOverhaulOrderNumber: number = environment.dateOverhaulOrderNumber;
  isNewRecordForDateOverhual: boolean = false;
  updatedCustomerDocOrder: number = environment.updatedCustomerDocOrder;
  isNewCustomerDocOrder: boolean = false;
  bookedDispatchOrderNumber: number = environment.bookedDispatchOrderNumber;
  isNewBookedOrderNumber: boolean = false;
  pickupPasswordOrderNumber: number = environment.pickupPasswordOrderNumber;
  isShowPickupPassword: boolean = false;
  isDownloadingCarrierTerms: boolean = false;
  businessPhone = null;
  brokerFeePaidDate:any
  paymentTerms:any
  priceToCarrierAdjusted:any
  subs: any = { };
  isPaymentTermsReadOnly:boolean = false;
  startTime: number;
  totalTime: number = 3600;
  warningShown = false;
  invoiceAccess = true;
  isDialogAlreadyClosed: boolean = false;
  truckOverhaulOrderNumber:number = environment.truckOverhaulOrderNumber;
  isNewRecordForTruckOverhual:boolean =false;
  isTenderOrder: boolean = false;
  parsedSpecialInstructions: any[] = [];

  constructor(private navigationService: NavigationService,
    private lookupService: LookupService,
    private fileService: FileService,
    private sharedService: SharedService,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef,
    private accountService: AccountService,
    private applicationInsights: ApplicationInsightsService,
    protected messageService: MessageService
    ) {
    super();
  }

  ngOnInit() {
    this.applicationInsights.trackEvent('InvoiceDetailComponent.Init', {
      userId: localStorage.getItem('userId') || 'anonymous',
      isAdmin: !!localStorage.getItem('isAdmin'),
      timestamp: new Date().toISOString()
    });

    this.isAdmin = !!localStorage.getItem('isAdmin');

    this.loadLookup('yesNoPartial');
    this.loadLookup('yesNoNa');
    this.loadLookup('yesNoNull');
    this.loadLookup('paymentMethod');
    this.loadLookup('fscpaidbycustomer');
    this.loadLookup('paymentTerms');
    this.loadLookup('sources');
    this.loadLookup('segment');
    this.loadLookup('subsegmentupfitter');
    this.loadLookup('reviewRequested');
    this.loadLookup('customerDocs')
    this.loadLookup('customerDocOptions')
    this.loadLookup('bookedBy')

    this.sharedService.currentStatus.subscribe((status:any)=>{
      this.carrierPaymentStatus = status
    })

    this.subs['carrierPaymentTermchanges'] = this.navigationService.carrierPaymentTerm$.subscribe(res => {
      this.paymentTerms = res
    });

    this.subs['priceToCarrierAdjusted'] = this.navigationService.priceToCarrierAdjusted$.subscribe(res => {
      this.priceToCarrierAdjusted = res
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['model'] != null && (changes['model'].firstChange || (changes['model'].currentValue != changes['model'].previousValue))) {
      if (this.model != null && !this.loaded) {
        
        this.applicationInsights.trackEvent('InvoiceDetailComponent.ModelLoaded', {
          invoiceId: this.model.id,
          invoiceNumber: this.model.number,
          orderId: this.model.orderId,
          paid: this.model.paid,
          userId: localStorage.getItem('userId') || 'anonymous',
          timestamp: new Date().toISOString()
        });

        this.parsedSpecialInstructions = this.parseSpecialInstructions(this.model?.order?.specialInstructions);
        this.startTime = Date.now();
        this.timer();
        this.ref.markForCheck();

        if (this.model.number && this.model.number > this.dateOverhaulOrderNumber) {
          this.isNewRecordForDateOverhual = true;
        }
        if (this.model.number && this.model.number > this.updatedCustomerDocOrder) {
          this.isNewCustomerDocOrder = true;
        }
        if (
          this.model.number &&
          this.model.number > this.bookedDispatchOrderNumber
        ) {
          this.isNewBookedOrderNumber = true;
        }
        if (this.model.number && this.model.number > this.truckOverhaulOrderNumber) {
          this.isNewRecordForTruckOverhual = true;
        }

        if (this.model.number && this.model.number > this.pickupPasswordOrderNumber) {
          this.isShowPickupPassword = true;
        }
        this.pickupPhones = this.getStringArray(this.model?.order?.pickupPhones, ';');
        this.deliveryPhones = this.getStringArray(this.model?.order?.deliveryPhones, ';');
        this.carrierPhones = this.getStringArray(this.model?.order?.carrierPhones, ';');
        this.businessPhone = this.model?.order?.carrierBusinessPhone;
        this.driverNames = this.getStringArray(this.model?.order?.driverName,',');
        this.driverPhones = this.sharedService.getDriverPhonesStringArray(this.model?.order?.driverPhone);
        this.brokerFeePaidDate = this.datePipe.transform(this.model.brokerFeePaidDate, 'MM/dd/yy', 'UTC');
        this.cargoLimit = this.getStringArray(this.model?.order?.cargoInsuranceLimit, ';');
        this.cargoInsuranceDeductible = this.getStringArray(this.model?.order?.cargoInsuranceDeductible, ';');
        this.isTenderOrder = this.model?.settings?.isTender;

        let temparr = [];
        let arr = [];
        arr  = this.cargoLimit.length > this.cargoInsuranceDeductible.length ? this.cargoLimit : this.cargoInsuranceDeductible;
        for (let index = 0; index < arr.length; index++) {
          let obj = [];
          obj = [this.cargoLimit[index] ? '$ '+ this.cargoLimit[index]+' ' : '- ',this.cargoInsuranceDeductible[index] ? ' $ '+ this.cargoInsuranceDeductible[index] : ' -'];
          temparr.push(obj);
        }
        this.cargoLimit = temparr;
        if (this.isNewRecordForDateOverhual) {
          this.customerExpectedDeliveryDates = this.model?.customerExpectedDeliveryDates;
          this.customerExpectedPickupDates = this.model?.customerExpectedPickupDates;
          this.carrierScheduledPickupDates = this.model?.carrierScheduledPickupDates;
          this.carrierScheduledDeliveryDates = this.model?.carrierScheduledDeliveryDates
          this.pickupNewETADates = this.model?.pickupNewETADates;
          this.deliveryNewETADates = this.model?.deliveryNewETADates;
        }
        if (this.model.dispatchedOn) {
          this.model.dispatchedOn = this.datePipe.transform(this.model.dispatchedOn, 'MM/dd/yy hh:mm a')
        }
        if (this.model.detailMetadata != null) {
          this.metadata = this.model.detailMetadata;
        } else {
          this.metadata = this.model.metadata;
        }

        if (this.model.formMetadata != null) {
          this.metadata = this.model.formMetadata;
          this.detailMetadata = this.model.detailMetadata;
        } else {
          console.warn('Form/Detail specific metadata not passed to invoice-detail control.');
          this.metadata = this.model.metadata;
        }
        if (this.model.paymentTerms == null && this.model?.order?.customerChargedType === 3) {
          if (this.model.order?.priceToCarrier != null && this.model.order?.balanceDue != null && this.model.order?.priceToCarrier <= this.model.order?.balanceDue) {
            // this.isPaymentTermsReadOnly = true;
            if (this.model.order?.carrierPaymentType == carrierPaymentType.Invoice) {
              this.isPaymentTermsReadOnly = false;
            } else {
              this.isPaymentTermsReadOnly = true;
            }
          }
        }
        this.loaded = true;
      }
    }
  }

  timer() {
    const currentTime = Date.now();
    const elapsedTime = (currentTime - this.startTime) / 1000;
    this.totalTime -= elapsedTime;


    if (this.totalTime < 0 && !this.isDialogAlreadyClosed) {
      this.totalTime = 0;
      this.cancel();
    }

    this.startTime = currentTime;

    if (Math.round(this.totalTime) === 120 && !this.warningShown) {
      this.messageService.add(this.toast(true, 'Kindly save the invoice details, only 2 minutes left for the invoice edit.'));
      this.warningShown = true;
    }

    if (this.totalTime > 0) {
      requestAnimationFrame(() => this.timer());
    }
  }

  setDateFormat(date: any) {
    return this.datePipe.transform(date, 'MM/dd/yyyy', 'UTC');
  }

  showOrder() {
    this.invoiceAccess =false;
    this.navigationService.showDetail(false);
    this.navigationService.setDetail('order', this.model?.order?.guid);
    this.sharedService.setData("invoiceOrderNumber", this.model?.order?.guid);
    // this.accountService.setAllowInvoiceEdit([this.model?.id]).subscribe(r => {
    // });
    this.totalTime=0;
    this.ref.markForCheck();
  }

  close() {
    if (this.dirty) {
      this.showCancelWarning = true;
    } else {
      this.cancel();
    }
  }

  confirmClose() {
    this.totalTime = 0;
    this.showCancelWarning = false;
    this.navigationService.showDetail(false);
  }

  cancel(){
    this.totalTime = 0;
    this.ref.markForCheck();
    this.onCancel.emit(this.model?.id ? [this.model?.id] : null);
    this.accountService.setAllowInvoiceEdit([this.model?.id]).subscribe(r => {
    });
    if(this.invoiceAccess){
      this.navigationService.showDetail(false);
      this.navigationService.viewInvoice(null);
      this.isDialogAlreadyClosed  = true;
    }
  }

  get paymentStatusText() {
    if (this.model != null) {
      return this.model.paid ? 'Paid' : 'Unpaid';
    }

    return null;
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
          this.lookups[key] = r;
      });
  }

  markClean() {
    this.dirty = false;
  }

  downloadInvoice() {
    this.applicationInsights.trackEvent('InvoiceDetailComponent.DownloadInvoice', {
      invoiceId: this.model?.id,
      invoiceNumber: this.model?.number,
      fileName: 'Invoice #' + this.model?.number + '.pdf',
      userId: localStorage.getItem('userId') || 'anonymous',
      timestamp: new Date().toISOString()
    });

    this.fileService.downloadInvoice(this.model.guid, 'Invoice #' + this.model.number + '.pdf')
      .subscribe(() => {
        /**/
      });
  }

  get anyCustomerContacts(): boolean {
    return this.model?.customerContacts?.length > 0;
  }

  downloadCarrierTerms() {
    if (this.isDownloadingCarrierTerms)
      return;

    this.isDownloadingCarrierTerms = true;
    this.ref.markForCheck();

    this.fileService.downloadCarrierTerms(this.model?.order?.guid, this.model?.order?.includeBoL, this.model?.order?.includePort, 'Carrier Terms Order ' + this.model?.order?.number + '.pdf', this.model?.order?.includeRidgeville)
      .subscribe(() => {
        this.isDownloadingCarrierTerms = false;
        this.ref.markForCheck();
      },
        err => {
          Sentry.captureException(err)
          this.applicationInsights.trackException(err);
          this.applicationInsights.trackEvent('InvoiceDetailComponent.DownloadCarrierTermsError', {
            invoiceId: this.model?.id,
            invoiceNumber: this.model?.number,
            orderId: this.model?.order?.id,
            orderNumber: this.model?.order?.number,
            error: err.message,
            userId: localStorage.getItem('userId') || 'anonymous',
            timestamp: new Date().toISOString()
          });
          this.isDownloadingCarrierTerms = false;
          this.ref.markForCheck();

          this.messageService.add({ severity: 'error', summary: 'Error occurred' });
        });
  }

  formatCurrency(value: string | number): string {
    return formatCurrency(value);
  }

  ngOnDestroy() {
    this.applicationInsights.trackEvent('InvoiceDetailComponent.Destroy', {
      invoiceId: this.model?.id,
      invoiceNumber: this.model?.number,
      userId: localStorage.getItem('userId') || 'anonymous',
      timestamp: new Date().toISOString()
    });

    this.safeUnsub('carrierPaymentTermchanges');
    this.safeUnsub('priceToCarrierAdjusted');
  }

  public safeUnsub(key: string) {
    if (this.subs != null) {
      if (this.subs[key] != null) {
        this.subs[key].unsubscribe();
      }
    }
  }
}
